import React, { Component } from "react";
import ConfirmationModal from "./ConfirmationModal";
import PropTypes from "prop-types";

class DeleteRevenueOpportunityModal extends Component {
  static propTypes = {
    onConfirmDelete: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ConfirmationModal
        actionDescription="Delete"
        buttonColor="grey"
        onConfirm={this.props.onConfirmDelete}
        menuTrigger={this.props.menuTrigger}
        icon={this.props.noIcon ? null : "trash"}
        warning
      >
        <p>Are you sure you want to delete this Revenue Opportunity?</p>
      </ConfirmationModal>
    );
  }
}

export default DeleteRevenueOpportunityModal;
